module.exports = __webpack_public_path__ + "img/certificate-EC-GTCB.07646b7b.jpg";